import React from "react";

export const CanonLawSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                fill="currentColor"
                d="M18.78 23.57h5.01v12.5a1 1 0 001 1h5.89a1 1 0 001-1v-12.5h5.01a1 1 0 001-1v-5.89a1 1 0 00-1-1h-5.01v-5.06a1 1 0 00-1-1h-5.89a1 1 0 00-1 1v5.06h-5.01a1 1 0 00-1 1v5.89a1 1 0 001 1zm1-5.89h5.01a1 1 0 001-1v-5.06h3.89v5.06a1 1 0 001 1h5.01v3.89h-5.01a1 1 0 00-1 1v12.5h-3.89v-12.5a1 1 0 00-1-1h-5.01zM40.478 40.366H14.993a1 1 0 000 2h25.485a1 1 0 000-2zM38.284 49.569h-21.1a1 1 0 000 2h21.1a1 1 0 100-2zM33.639 46.968a1 1 0 000-2H21.832a1 1 0 000 2z" />
            <path
                fill="currentColor"
                d="M52.15 5.09V3a1 1 0 00-1-1H39.62a1 1 0 00-.71 1.71l.51.51H16.05l.51-.51a1 1 0 00-.7-1.71H4.33a1 1 0 00-1 1v11.53a.993.993 0 00.61.92.909.909 0 00.39.08 1 1 0 00.7-.29l.51-.51v34.54l-.51-.51a1 1 0 00-1.7.71V61a1 1 0 001 1h11.53a1 1 0 00.7-1.71l-.56-.55h23.47l-.56.55a1 1 0 00.71 1.71h11.53a1 1 0 001-1V49.47a1.006 1.006 0 00-1.71-.71l-.47.48V25c.22.01.44.03.67.03a10.027 10.027 0 001.51-19.94zM14 57.74l-6.46-6.47V12.73l6.51-6.51h27.37l1.92 1.91a10 10 0 004.63 16.53v26.58l-6.5 6.5zm36.64-34.71A8.035 8.035 0 1158.67 15a8.045 8.045 0 01-8.03 8.03z" />
            <path
                fill="currentColor"
                d="M53.93 9.32h-6.58a1 1 0 00-1 1v9.35a.992.992 0 001.7.71l2.59-2.56 2.58 2.56a1.024 1.024 0 00.71.29.986.986 0 00.38-.07 1 1 0 00.62-.93v-9.35a1 1 0 00-1-1zm-1 7.95l-1.59-1.57a1 1 0 00-.7-.29 1.024 1.024 0 00-.71.29l-1.58 1.57v-5.95h4.58z" />
        </svg>
    )
}